import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    jsapiConfig(data) {
        data = Object.assign(data, {api_throw_exception: false})
        return axios.request({
            url: "app/wxshare",
            method: "post",
            data,
            baseURL:process.env.VUE_APP_API_BASE_URL_MDC
        });
    }
}
